import { memo } from 'react'
import { useNavigate } from 'react-router-dom'

import s from './ExpiredModal.module.scss'

import { CustomButton } from 'components/UI/CustomButton/CustomButton'
import { CModal } from 'components/UI/Modal/CModal'

const SessionIsExpiredModal = memo((props: { onHide: () => void }) => {
  const { onHide } = props

  const navigate = useNavigate()

  const closeButtonHandler = () => {
    onHide()
    navigate('../login', { replace: true })
  }

  return (
    <CModal variant="secondary" onHide={onHide}>
      <CModal.Info className={s.infoWrapper}>
        <CModal.Title>Your session has expired</CModal.Title>
        <CustomButton variant="secondary" onClick={closeButtonHandler} size="240" className={s.closeButton}>
          Close
        </CustomButton>
      </CModal.Info>
    </CModal>
  )
})

export default SessionIsExpiredModal
